<!-- 积分兑换 -->
<template>
   <div class="page_content">
      <!-- 会员信息卡片 -->
      <el-card class="member-card" body-style="padding: 10px;">
         <div slot="header" class="clearfix">
            <span class="card-title">会员信息</span>
            <el-button style="float: right; padding: 3px 0" type="text" @click="clearMember">清空</el-button>
         </div>
         <div class="member-info">
            <el-form :inline="true" size="small" @submit.native.prevent="searchMember">
               <el-form-item label="会员搜索:">
                  <el-input v-model="memberSearchText" placeholder="请输入手机号/姓名/卡号" clearable @keyup.enter.native="searchMember" style="width: 250px;">
                     <el-button slot="append" icon="el-icon-search" @click="searchMember"></el-button>
                  </el-input>
               </el-form-item>
            </el-form>

            <div v-if="selectedMember.memId" class="member-detail" style="margin-top: 10px;">
               <el-row :gutter="15" style="margin-bottom: 8px;">
                  <el-col :span="6">
                     <div class="member-item">
                        <span class="label">会员姓名:</span>
                        <span class="value">{{ selectedMember.name }}</span>
                     </div>
                  </el-col>
                  <el-col :span="6">
                     <div class="member-item">
                        <span class="label">手机号码:</span>
                        <span class="value">{{ selectedMember.phone }}</span>
                     </div>
                  </el-col>
                  <el-col :span="6">
                     <div class="member-item">
                        <span class="label">当前积分:</span>
                        <span class="value points">{{ selectedMember.points }}</span>
                     </div>
                  </el-col>
                  <el-col :span="6">
                     <div class="member-item">
                        <span class="label">储值余额:</span>
                        <span class="value">{{ selectedMember.storedBalance }}</span>
                     </div>
                  </el-col>
               </el-row>
               <el-row :gutter="15">
                  <el-col :span="6">
                     <div class="member-item">
                        <span class="label">会员卡号:</span>
                        <span class="value">{{ selectedMember.cardNo }}</span>
                     </div>
                  </el-col>
                  <el-col :span="6">
                     <div class="member-item">
                        <span class="label">卡类型:</span>
                        <span class="value">{{ selectedMember.cardType }}</span>
                     </div>
                  </el-col>
                  <el-col :span="6">
                     <div class="member-item">
                        <span class="label">注册门店:</span>
                        <span class="value">{{ selectedMember.registerStore }}</span>
                     </div>
                  </el-col>
                  <el-col :span="6">
                     <div class="member-item">
                        <span class="label">身份证号:</span>
                        <span class="value">{{ selectedMember.idCard }}</span>
                     </div>
                  </el-col>
               </el-row>
            </div>

            <div v-else class="no-member">
               <i class="el-icon-user"></i>
               <span>请先搜索并选择会员</span>
            </div>
         </div>
      </el-card>

      <!-- 赠品选择区域 -->
      <el-card class="gift-card" style="margin-top: 5px;" body-style="padding: 10px;">
         <div slot="header" class="clearfix">
            <span class="card-title">赠品选择</span>
            <el-button style="float: right; padding: 3px 0" type="text" @click="resetGiftSelection">清空</el-button>
         </div>

         <div class="gift-search">
            <el-form :inline="true" size="small" @submit.native.prevent="openSearch('2938338310', 0, 'bgmName', 'bgmName,bgmId')">
               <el-form-item label="赠品选择" prop="bgmName">
                  <label slot="label" :style="$common.labelStyle('赠品选择')" v-html="$common.htmlLabel('赠品选择')"></label>
                  <el-input class="form_codition" clearable v-model="sendDataInfo.bgmName" @keyup.enter.native="openSearch('2938338310', 0, 'bgmName', 'bgmName,bgmId')">
                     <el-button @click="openSearch('2938338310', 0, 'bgmName', 'bgmName,bgmId')" slot="append" icon="el-icon-search">
                     </el-button>
                  </el-input>
               </el-form-item>
            </el-form>
         </div>

         <el-table :data="giftList" :height="250" border style="width: 100%" size="small">
            <el-table-column prop="giftCode" label="赠品编码" width="120"></el-table-column>
            <el-table-column prop="giftName" label="赠品名称" min-width="150"></el-table-column>
            <el-table-column prop="spec" label="规格" width="120"></el-table-column>
            <el-table-column prop="manufacturer" label="生产厂家" width="120"></el-table-column>
            <el-table-column prop="requiredPoints" label="所需积分" width="100" align="center">
               <template slot-scope="scope">
                  <el-tag type="warning">{{ scope.row.requiredPoints }}</el-tag>
               </template>
            </el-table-column>
            <el-table-column prop="stock" label="库存数量" width="100" align="center">
               <template slot-scope="scope">
                  <el-tag :type="scope.row.stock > 0 ? 'success' : 'danger'">{{ scope.row.stock }}</el-tag>
               </template>
            </el-table-column>

            <el-table-column label="兑换数量" width="120" align="center">
               <template slot-scope="scope">
                  <el-input v-model="scope.row.exchangeQty" :min="0" type="number" :max="scope.row.stock" size="mini" @input="onExchangeQtyChange">
                  </el-input>
               </template>
            </el-table-column>
            <el-table-column label="备注" width="120" align="center">
               <template slot-scope="scope">
                  <el-input v-model="scope.row.remark" size="mini"></el-input>
               </template>
            </el-table-column>
            <el-table-column label="操作" width="80" align="center">
               <template slot-scope="scope">
                  <el-button type="text" size="mini" @click="removeGift(scope.$index)" style="color: #f56c6c;">
                     <i class="el-icon-delete"></i> 删除
                  </el-button>
               </template>
            </el-table-column>
         </el-table>
      </el-card>

      <!-- 兑换汇总 -->
      <el-card class="summary-card" style="margin-top: 5px;" body-style="padding: 10px;">
         <div slot="header" class="clearfix">
            <span class="card-title">兑换汇总</span>
         </div>

         <div class="exchange-summary">
            <el-row :gutter="15">
               <el-col :span="8">
                  <div class="summary-item">
                     <span class="label">选择赠品数量:</span>
                     <span class="value">{{ selectedGifts.length }} 种</span>
                  </div>
               </el-col>
               <el-col :span="8">
                  <div class="summary-item">
                     <span class="label">总计所需积分:</span>
                     <span class="value total-points">{{ totalRequiredPoints }}</span>
                  </div>
               </el-col>
               <el-col :span="8">
                  <div class="summary-item">
                     <span class="label">兑换后剩余积分:</span>
                     <span class="value remaining-points">{{ remainingPoints?remainingPoints:0 }}</span>
                  </div>
               </el-col>
            </el-row>

         </div>

         <!-- 兑换按钮 -->
         <div class="exchange-actions" style="margin-top: 15px; text-align: center;">
            <el-button type="primary" size="medium" :disabled="!canExchange" @click="confirmExchange">
               <i class="el-icon-present"></i>
               确认兑换
            </el-button>
            <el-button size="medium" @click="resetAll">重置</el-button>
         </div>
      </el-card>

      <!-- 会员搜索弹窗 -->
      <el-dialog title="选择会员" :visible.sync="memberDialogVisible" width="80%" @open="handleMemberDialogOpen" @close="handleMemberDialogClose">
         <el-table 
            ref="memberTable"
            :data="memberList" 
            @row-click="handleRowClick" 
            @row-dblclick="selectMember" 
            highlight-current-row 
            style="cursor: pointer;"
            :current-row-key="currentSelectedMember ? currentSelectedMember.memId : null"
            row-key="memId"
            @keydown.native="handleTableKeyDown"
            tabindex="0">
            <el-table-column prop="cardNo" label="会员卡号" width="120" />
            <el-table-column prop="cardType" label="卡类型" width="100" />
            <el-table-column prop="name" label="姓名" width="100" />
            <el-table-column prop="phone" label="手机号" width="120" />
            <el-table-column prop="idCard" label="身份证号" min-width="160" />
            <el-table-column prop="registerStore" label="注册门店" width="120" />
            <el-table-column prop="pointBalance" label="积分余额" width="100" align="center" />
            <el-table-column prop="storedBalance" label="储值余额" width="100" align="center" />
         </el-table>
         <div slot="footer" class="dialog-footer">
            <el-button @click="closeMemberDialog">取消</el-button>
            <el-button type="primary" @click="confirmSelectMember" :disabled="!currentSelectedMember">确认选择</el-button>
         </div>
      </el-dialog>

      <!-- 兑换确认弹窗 -->
      <el-dialog title="确认兑换" :visible.sync="confirmDialogVisible" width="50%">
         <div class="confirm-content">
            <div class="confirm-member">
               <h4>会员信息:</h4>
               <p>姓名: {{ selectedMember.name }} | 手机: {{ selectedMember.phone }} | 当前积分: {{ selectedMember.points }}</p>
            </div>

            <div class="confirm-gifts">
               <h4>兑换赠品:</h4>
               <ul>
                  <li v-for="gift in selectedGifts" :key="gift.id">
                     {{ gift.giftName }} × {{ gift.exchangeQty }} ({{ gift.requiredPoints * gift.exchangeQty }} 积分)
                  </li>
               </ul>
            </div>

            <div class="confirm-summary">
               <p><strong>总计消耗积分: {{ totalRequiredPoints }}</strong></p>
               <p><strong>兑换后剩余积分: {{ remainingPoints }}</strong></p>
            </div>
         </div>

         <div slot="footer" class="dialog-footer">
            <el-button @click="confirmDialogVisible = false">取消</el-button>
            <el-button type="primary" @click="executeExchange" :loading="exchangeLoading">确认兑换</el-button>
         </div>
      </el-dialog>
      <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth">
         <SearchScheme ref="searchScheme" :id="seId" @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" :parentSearchData="parentSearchData" />
      </el-dialog>
   </div>
</template>

<script>
import SearchScheme from "../../../byComponents/SearchScheme.vue"
export default {
   components: {
      SearchScheme
   },
   data() {
      return {
         // 会员相关
         memberSearchText: '',
         selectedMember: {
            memId: null,
            name: '',
            phone: '',
            idCard: '',
            points: 0,
            registerStore: '',
            pointBalance: 0,
            storedBalance: 0,
            cardNo: '',
            cardType: '',
      
         },
         memberList: [],
         memberDialogVisible: false,
         currentSelectedMember: null, // 当前选中的会员（用于单击选中）
         currentMemberIndex: 0, // 当前选中的会员索引

         // 赠品相关
         giftSearchText: '',
         giftList: [],
         selectedGifts: [],


         // 兑换相关
         totalRequiredPoints: 0,
         confirmDialogVisible: false,
         exchangeLoading: false,
         DialogVisible: false, //判断是否打开检索方案弹框
         seTitle: "", //检索方案的名称
         seType: "", //检索方案查询条件字段
         seWidth: "", //检索方案弹框的宽度
         sField: "", //赋值字段
         parentSearchData: {}, //检索方案补充的查询列表的查询条件
         sendDataInfo: {
            bgmName: '',
            bgmId: ''
         },
         storeId: ''
      }
   },

   computed: {
      // 兑换后剩余积分
      remainingPoints() {
         return this.selectedMember.points - this.totalRequiredPoints;
      },
      // 是否可以兑换
      canExchange() {
         return this.selectedMember.memId &&
            this.giftList.length > 0 &&
            this.totalRequiredPoints > 0 
      }
   },
   created() {
       this.$http.storemastGetCurStore().then(res => {
             if (res.status == 200) {
                this.storeId = res.result.storeId
          
             }
          })
   },
   methods: {

      // 检索Id, 索引(表格中), 标识
      openSearch(sId, index, type, sField) {
         this.seId = sId //检索方案Id
         this.sField = sField //赋值字段
         this.DialogVisible = true //判断是否打开弹框
         this.seType = type
         this.parentSearchData.goodType = 2
      },

      // 赋值字段
      paramValue(val) {
         this.selectedGifts = val
      },
      //检索方案返回的数据
      changeInputModel(val) {
         if (val) {
            // 如果是赠品选择
            if (this.seType === 'bgmName') {
               this.handleGiftSelectionFromSearch(val);
            } else {
               this.paramValue(val);
            }
         }
         this.DialogVisible = false
      },

      // 处理从检索方案选择的赠品
      handleGiftSelectionFromSearch(selectedData) {
         // 检查是否已存在相同的商品（根据bgmId判断）
         const existingIndex = this.giftList.findIndex(gift => gift.giftId === selectedData.bgmId && gift.batchno === selectedData.batchno);

         if (existingIndex !== -1) {
            // 如果商品已存在，累加数量
            this.giftList[existingIndex].exchangeQty += 1;
            this.$message.success(`已将 ${selectedData.bgmName} 的数量增加1，当前数量：${this.giftList[existingIndex].exchangeQty}`);
         } else {
            // 如果商品不存在，添加新商品
            const giftItem = {
               giftId: selectedData.bgmId,
               giftName: selectedData.bgmName,
               giftCode: selectedData.bgmCode,
               requiredPoints: selectedData.point || 0,
               stock: selectedData.num || 0,
               spec: selectedData.spec || '',
               manufacturer: selectedData.manufacturer || '',
               price: selectedData.price || 0,
               batchno: selectedData.batchno || '',
               exchangeQty: 1, // 默认兑换数量为1
               remark: '', // 初始化备注
               // 保留原始数据
               originalData: selectedData
            };
            this.giftList.push(giftItem);
            this.$message.success(`已添加赠品: ${selectedData.bgmName}`);
         }

         // 更新选中的赠品列表和总积分
         this.selectedGifts = this.giftList.filter(gift => gift.exchangeQty > 0);
         this.calculateTotalPoints();
      },
      handleGiftSelection(selection) {
         this.selectedGifts = selection;
         this.calculateTotalPoints();
      },

      // 处理兑换数量变化
      onExchangeQtyChange() {
         // 确保数量为数字类型，并过滤出数量大于0的商品
         this.giftList.forEach(gift => {
            gift.exchangeQty = parseInt(gift.exchangeQty) || 0;
         });

         // 更新选中的赠品列表（数量大于0的商品）
         this.selectedGifts = this.giftList.filter(gift => gift.exchangeQty > 0);

         // 重新计算总积分
         this.calculateTotalPoints();
      },

      // 计算总积分
      calculateTotalPoints() {
         this.totalRequiredPoints = this.selectedGifts.reduce((total, gift) => {
            return total + (gift.requiredPoints * gift.exchangeQty);
         }, 0);
      },

      getSeWidth(e) {
         console.log(e)
         this.seWidth = e + "%"
      },
      getWidth(e) {
         console.log(e)
         this.exWidth = e + "%"
      },
      getSearchName(e) {
         console.log(e)
         this.seTitle = e
      },
      // 搜索会员
      async searchMember() {
         if (!this.memberSearchText.trim()) {
            this.$message.warning('请输入搜索关键词');
            return;
         }

         try {
            // 调用会员查询API
            const response = await this.$http.memberDeskQueryMem({
               keyWord: this.memberSearchText, // 手机号搜索
             
            });

            // 映射API返回的字段到弹窗显示的字段
            const mappedList = response.result.list.map(member => ({
               cardNo: member.cardCode || '',
               cardType: member.capName || '',
               name: member.memName || '',
               phone: member.memPhone || '',
               idCard: member.memIdcard || '',
               points: member.pointBalance || 0,
               registerStore: member.storeName || '',
               pointBalance: member.pointBalance || 0,
               storedBalance: member.storedBalance || 0,
               memId: member.memId || '', // 添加会员ID
             
            }));

            if (mappedList.length === 1) {
               // 如果只有一个结果，直接选择
               this.selectMember(mappedList[0]);
            } else if (mappedList.length > 1) {
               // 多个结果，显示选择弹窗
               this.memberList = mappedList;
               this.memberDialogVisible = true;
               // 默认选中第一条记录
               this.currentMemberIndex = 0;
               this.$nextTick(() => {
                  if (this.memberList.length > 0) {
                     this.currentSelectedMember = this.memberList[0];
                     this.$refs.memberTable.setCurrentRow(this.memberList[0]);
                  }
               });
            }
         } catch (error) {
            this.$message.error('搜索会员失败');
         }
      },

      // 处理单击选中行
      handleRowClick(row) {
         this.currentSelectedMember = row;
      },

      // 确认选择会员（按钮点击）
      confirmSelectMember() {
         if (this.currentSelectedMember) {
            this.selectMember(this.currentSelectedMember);
         }
      },

      // 关闭会员选择弹窗
      closeMemberDialog() {
         this.memberDialogVisible = false;
         this.currentSelectedMember = null;
         this.currentMemberIndex = 0;
      },

      // 会员弹窗打开事件
      handleMemberDialogOpen() {
         this.$nextTick(() => {
            // 聚焦到表格
            if (this.$refs.memberTable) {
               this.$refs.memberTable.$el.focus();
            }
            // 默认选中第一条记录
            if (this.memberList.length > 0) {
               this.currentMemberIndex = 0;
               this.currentSelectedMember = this.memberList[0];
               this.$refs.memberTable.setCurrentRow(this.memberList[0]);
            }
         });
      },

      // 会员弹窗关闭事件
      handleMemberDialogClose() {
         this.currentSelectedMember = null;
         this.currentMemberIndex = 0;
      },

      // 处理表格键盘事件
      handleTableKeyDown(event) {
         if (this.memberList.length === 0) return;

         switch (event.key) {
            case 'ArrowDown':
               event.preventDefault();
               this.currentMemberIndex = Math.min(this.currentMemberIndex + 1, this.memberList.length - 1);
               this.selectCurrentMember();
               break;
            case 'ArrowUp':
               event.preventDefault();
               this.currentMemberIndex = Math.max(this.currentMemberIndex - 1, 0);
               this.selectCurrentMember();
               break;
            case 'Enter':
               event.preventDefault();
               if (this.currentSelectedMember) {
                  this.selectMember(this.currentSelectedMember);
               }
               break;
            case 'Escape':
               event.preventDefault();
               this.closeMemberDialog();
               break;
         }
      },

      // 选中当前索引的会员
      selectCurrentMember() {
         if (this.memberList[this.currentMemberIndex]) {
            this.currentSelectedMember = this.memberList[this.currentMemberIndex];
            this.$refs.memberTable.setCurrentRow(this.memberList[this.currentMemberIndex]);
         }
      },

      // 选择会员
      selectMember(member) {
         this.selectedMember = {
            ...member,
            points: member.pointBalance || member.memPointbalance || 0  // 确保积分字段正确
         };
         this.memberDialogVisible = false;
         this.currentSelectedMember = null; // 重置当前选中状态
         this.memberSearchText = `${member.name} (${member.phone})`;
         // this.$message.success(`已选择会员: ${member.name}`);


      },

      // 清空会员
      clearMember() {
         this.selectedMember = {  };
         this.memberSearchText = '';
         this.resetGiftSelection();
         this.giftSearchText = '';
         this.giftList = [];
      },








      // 确认兑换
      confirmExchange() {
         if (!this.canExchange) {
            this.$message.warning('请检查兑换条件');
            return;
         }
         this.confirmDialogVisible = true;
      },

      // 执行兑换
      async executeExchange() {
         this.exchangeLoading = true;

         try {

            const res = await this.$http.memRedeemRedeem({
               bgmList: this.selectedGifts.map(gift => ({
                  bgmId: gift.giftId,
                  costPoint: gift.requiredPoints * gift.exchangeQty,
                  num: gift.exchangeQty,
                  remark: gift.remark
               })),
               memId: this.selectedMember.memId,
               storeId: this.storeId,
            });
            if (res.status === 200) {
               this.$message.success('兑换成功！');
   
               this.confirmDialogVisible = false;
               this.resetAll();
         

            } else {
               this.$message.error(res.message);
               return;
            }
                    // 更新会员积分
            this.selectedMember.points = this.remainingPoints;
               // 重置选择
            this.resetGifts();

         } catch (error) {
            this.$message.error('兑换失败，请重试');
         } finally {
            this.exchangeLoading = false;
         }
      },

      // 模拟提交兑换API
      async submitExchange() {
         // 模拟网络延迟
         return new Promise((resolve) => {
            setTimeout(() => {
               resolve({ success: true });
            }, 2000);
         });
      },

      // 重置赠品选择
      resetGifts() {
         this.giftList.forEach(gift => {
            gift.exchangeQty = 0;
         });
         this.selectedGifts = [];
         this.totalRequiredPoints = 0;
      },

      // 重置所有
      resetAll() {

         this.resetGiftSelection();
         this.giftSearchText = '';
         this.giftList = [];
         this.clearMember();
      },
      resetGiftSelection() {
         this.giftList = [];
         this.totalRequiredPoints = 0;
      },

      // 删除赠品
      removeGift(index) {
         const gift = this.giftList[index];
         this.giftList.splice(index, 1);

         // 重新计算选中的赠品和总积分
         this.selectedGifts = this.giftList.filter(gift => gift.exchangeQty > 0);
         this.calculateTotalPoints();

         this.$message.success(`已删除赠品: ${gift.giftName}`);
      }
   },


}
</script>

<style scoped>
.page_content {
   padding: 5px;
   background-color: #f5f5f5;
   min-height: 100vh;
   overflow: auto;
}

.card-title {
   font-size: 16px;
   font-weight: bold;
   color: #303133;
}

.member-info {
   min-height: 100px;
}

.member-detail {
   margin-top: 15px;
   padding: 12px;
   background-color: #f8f9fa;
   border-radius: 4px;
}

.member-item {
   margin-bottom: 8px;
}

.member-item .label {
   color: #606266;
   margin-right: 8px;
}

.member-item .value {
   color: #303133;
   font-weight: 500;
}

.member-item .points {
   color: #e6a23c;
   font-size: 18px;
   font-weight: bold;
}

.no-member {
   text-align: center;
   padding: 30px;
   color: #909399;
}

.no-member i {
   font-size: 40px;
   margin-bottom: 8px;
   display: block;
}

.gift-search {
   margin-bottom: 15px;
}

.summary-item {
   text-align: center;
}

.summary-item .value {
   font-size: 18px;
   font-weight: bold;
   color: #303133;
}

.summary-item .total-points {
   color: #e6a23c;
}

.summary-item .remaining-points {
   color: #67c23a;
}

.selected-gifts {
   margin-top: 20px;
}

.selected-gifts h4 {
   margin-bottom: 10px;
   color: #303133;
}

.exchange-actions {
   border-top: 1px solid #ebeef5;
   padding-top: 15px;
}

.confirm-content {
   padding: 20px;
}

.confirm-member,
.confirm-gifts,
.confirm-summary {
   margin-bottom: 20px;
}

.confirm-gifts ul {
   list-style-type: none;
   padding: 0;
}

.confirm-gifts li {
   padding: 5px 0;
   border-bottom: 1px solid #ebeef5;
}

.confirm-summary p {
   font-size: 16px;
   margin: 10px 0;
}
</style>
